import './style.css';
import { createScene } from './scene/Scene';
import { createCamera, createControls } from './scene/Camera';
import { createRenderer } from './scene/Renderer';
import { createLights } from './scene/Light';

import { TerrainGenerator } from './terrain/TerrainGenerator';
import { TerrainGUI } from './ui/GUI';
import * as THREE from 'three';

const scene = createScene();
const camera = createCamera();
const renderer = createRenderer();
const controls = createControls(camera, renderer);

document.body.appendChild(renderer.domElement);

// === add terrain ===

const terrainGenerator = new TerrainGenerator({
    size: 50,
    segments: 100,
    amplitude: 5,
    scale: 0.1,
    seed: 'my-terrain',
    useVertexColors: true,
    useFBM: true,          // FBM 활성화
    octaves: 5,            // 옥타브 수
    persistence: 0.5,      // 진폭 감소율
    lacunarity: 2.0        // 주파수 증가율
});

const terrain = terrainGenerator.generate();
scene.add(terrain);

// === GUI 추가 ===

const gui = new TerrainGUI(terrainGenerator);

// === add lighting ===

const lights = createLights(scene);

// === set camera position
camera.position.set(30, 30, 30);
controls.target.set(0, 0, 0);       // 지형 중심을 바라봄

// 키보드 이벤트 리스너

window.addEventListener('resize', () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
});

window.addEventListener('keydown', (event) => {
    if (event.key === 'w') {
        const material = terrain.material;
        material.wireframe = !material.wireframe;
    }
});

window.addEventListener('beforeunload', () => {
    gui.destroy();
});

// animation loop

function animate() {
    requestAnimationFrame(animate);
    controls.update();
    renderer.render(scene, camera);
};

animate();

